
































































































































import Vue from "vue";
import { mapState } from "vuex";
import { RootState } from "@/store";

// model
import { formatCurrency } from "@/utility/Formatter";
import { CashDetail } from "@/model/data/CashDetail";
import { CashTypeEnum } from "@/model/data/enums/CashTypeEnum";
import { StockTypeEnum } from "@/model/data/enums/StockTypeEnum";

export default Vue.extend({
    data() {
        return {
            CashTypeEnum,
        };
    },
    props: {
        /**
         * Sono i conteggi, è il contenuto della tabella
         */
        cashDetails: { type: Array as () => CashDetail[], required: true },

        /**
         * Settare a true se si vuole il footer con il totale di quantità e il totale di importo suddiviso per valuta
         */
        showTotals: Boolean,

        /**
         * Settare a true per visualizzare l'icona (banconote o monete) in una nuova colonna a sinistra
         */
        showCashType: Boolean,

        /**
         * Settare a true per nascondere gli headers
         */
        hideDefaultHeader: Boolean,

        model: String,

        backgroundColor: { type: String, default: "" },

        hideBoldTotal: { type: Boolean, required: false, default: false },

        stockType: { type: Number as () => StockTypeEnum, required: false, default: StockTypeEnum.Unknown },
    },
    computed: {
        ...mapState({
            crc: (c: RootState) => c.application.startupData.coinRollsConfiguration,
        }),
        headers(): any {
            let computedHeaders: any = [];
            if (this.showCashType) {
                computedHeaders.push({
                    text: "",
                    value: "cashType",
                    width: "10%",
                });
            }
            computedHeaders.push(
                {
                    text: this.$t("common.denomination"),
                    value: "denomination",
                    align: "left",
                    width: "30%",
                },
                {
                    text: this.$t("common.quantity"),
                    value: "quantity",
                    align: "center",
                    width: "30%",
                },
                {
                    text: this.$t("common.total"),
                    value: "total",
                    align: "right",
                    width: "30%",
                }
            );

            return computedHeaders;
        },

        totalQuantity(): number {
            let total: number = 0;
            this.cashDetails.forEach((cashDetail) => {
                total = total + cashDetail.quantity;
            });
            return total;
        },

        distinctCurrency(): string[] {
            let currency: string[] = [];
            this.cashDetails.forEach((cashDetail) => {
                if (!currency.includes(cashDetail.denomination.currency)) currency.push(cashDetail.denomination.currency);
            });
            return currency;
        },

        cashDetailsSorted() {
            if (this.cashDetails && this.cashDetails.length) {
                return [...this.cashDetails]
                    .filter((c) => c.denomination.currency != "XXX")
                    .sort((a, b) => {
                        return (
                            a.denomination.currency.localeCompare(b.denomination.currency) ||
                            b.denomination.type - a.denomination.type ||
                            a.denomination.value - b.denomination.value
                        );
                    });
            }
            return [];
        },
    },
    methods: {
        formatCurrency,

        getTotalByCurrency(currency: string): number {
            let total: number = 0;
            this.cashDetails.forEach((cashDetail) => {
                if (cashDetail.denomination.currency == currency) total = total + cashDetail.quantity * cashDetail.denomination.value;
            });
            return Math.abs(total);
        },
    },
});
